import { render } from "./calculate-savings.html?vue&type=template&id=4ddb061d&scoped=true&lang=html&external"
import script from "./calculate-savings.component.vue?vue&type=script&lang=js"
export * from "./calculate-savings.component.vue?vue&type=script&lang=js"

import "./_calculate-savings.mobile.scss?vue&type=style&index=0&id=4ddb061d&lang=scss&scoped=true&external"
import "./_calculate-savings.desktop.scss?vue&type=style&index=1&id=4ddb061d&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddb061d"]])

export default __exports__